/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_UndoInputs */

const en_wc_tut_keys_undo = /** @type {(inputs: Wc_Tut_Keys_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo / redo`)
};

/**
* | output |
* | --- |
* | "Undo / redo" |
*
* @param {Wc_Tut_Keys_UndoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_undo = /** @type {((inputs?: Wc_Tut_Keys_UndoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_UndoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_undo(inputs)
});
export { wc_tut_keys_undo as "wc.tut.keys.undo" }